import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import { Cover } from '../Cover'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  return (
    <AppContainer className={globalClasses.join(' ')}>
      <Cover
        title={'Wie die Schweiz in Rekordzeit ein Solargesetz erhält'}
        lead={
          'Ein Coup! Ein Putsch! In nicht einmal einem Monat macht das Parlament ein Gesetz und hebeln den Umweltschutz aus. Drahtzieher sind ein Walliser und ein Zürcher. Genese eines Solarkrimis.'
        }
      />
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`
export default MainComponent
